import { render, staticRenderFns } from "./orderAppraise.vue?vue&type=template&id=6fca4d7f&scoped=true&"
import script from "./orderAppraise.vue?vue&type=script&lang=js&"
export * from "./orderAppraise.vue?vue&type=script&lang=js&"
import style0 from "./orderAppraise.vue?vue&type=style&index=0&id=6fca4d7f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca4d7f",
  null
  
)

export default component.exports